import { combineReducers } from "redux";
import routeReducer from "./routeReducer";
import vehiclesReducer from "./vehicleReducer";
import metricsReducer from "./metricsReducer";
import popupReducer from "./popupReducer";
import vehicleSelectionReducer from "./vehicleSelectionReducer";
import vehicleListReducer from "./vehicleListReducer";
import mapDateSelectionReducer from "./mapDateSelectionReducer";
import settingsReducer from "./settingsReducer";
import resetRelayReducer from "./resetRelayReducer";
import logsReducer from "./logsReducer";
import notificationsReducer from "./notificationsReducer";
import lastOnlineReducer from "./lastOnlineReducer";
import adminReducer from "./adminReducer";
import alertPreferencesReducer from "./alertPreferencesReducer";
import customerGroupPerEmailReducer from "./customerGroupPerEmailReducer";
import fleetReducer from "./fleetReducer";
import relayReducer from "./relayReducer";
import alertHistoryReducer from "./alertHistoryReducer";

const rootReducer = combineReducers({
  vehicleRoutes: routeReducer,
  vehicle: vehiclesReducer,
  metrics: metricsReducer,
  popupView: popupReducer,
  vehicleSelection: vehicleSelectionReducer,
  vehicleList: vehicleListReducer,
  mapDate: mapDateSelectionReducer,
  settings: settingsReducer,
  resetRelay: resetRelayReducer,
  logs: logsReducer,
  notifications: notificationsReducer,
  lastOnline: lastOnlineReducer,
  emails: adminReducer,
  alertPreferences: alertPreferencesReducer,
  customerGroupPerEmail: customerGroupPerEmailReducer,
  fleet: fleetReducer,
  relay: relayReducer,
  alertHistory: alertHistoryReducer,
});

export default rootReducer;

//export type State = ReturnType<typeof rootReducer>;
